import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

export type Rolle = 'Verwalter' | 'Tester' | 'Leser' | null;

export interface AuthZustand {
  laedt: boolean;
  angemeldet: boolean;
  rolle: Rolle;
  sub: string | null;
  anzeigename: string | null;
  darfTesten: boolean; // Tester oder Verwalter
  istVerwalter: boolean;
}

const RANG: Record<string, number> = { Leser: 1, Tester: 2, Verwalter: 3 };

function höchsteRolle(groups: unknown): Rolle {
  if (!Array.isArray(groups)) return null;
  const treffer = groups
    .filter((g): g is string => typeof g === 'string' && g in RANG)
    .sort((a, b) => RANG[b] - RANG[a]);
  return (treffer[0] as Rolle) ?? null;
}

export function useRolle(): AuthZustand {
  const [zustand, setZustand] = useState<AuthZustand>({
    laedt: true,
    angemeldet: false,
    rolle: null,
    sub: null,
    anzeigename: null,
    darfTesten: false,
    istVerwalter: false,
  });

  useEffect(() => {
    let aktiv = true;

    async function laden() {
      try {
        const session = await fetchAuthSession();
        const claims = session.tokens?.idToken?.payload ?? {};
        const rolle = höchsteRolle(claims['cognito:groups']);
        if (!aktiv) return;
        setZustand({
          laedt: false,
          angemeldet: Boolean(session.tokens),
          rolle,
          sub: (claims.sub as string) ?? null,
          anzeigename:
            (claims.preferred_username as string) ?? (claims.email as string) ?? null,
          darfTesten: rolle === 'Tester' || rolle === 'Verwalter',
          istVerwalter: rolle === 'Verwalter',
        });
      } catch {
        if (aktiv) setZustand((z) => ({ ...z, laedt: false, angemeldet: false }));
      }
    }

    void laden();
    const stop = Hub.listen('auth', () => void laden());
    return () => {
      aktiv = false;
      stop();
    };
  }, []);

  return zustand;
}
